<template>
  <div v-if="props.hasData">
    <v-btn variant="outlined" color="red" prepend-icon="mdi-mail" @click="openDialog">
      거래명세서 생성
    </v-btn>
  </div>
  <v-dialog v-model="dialog" width="900">
    <v-card>
      <v-card-title class="wage-transaction-title">거래명세서 생성
    {{ store.state.AdminYYMM }}    

      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-table>
                <tbody> 
                  <tr>
                    <td style="width: 120px;">작성일자</td>
                    <td>
                      <v-text-field
                        v-model="inputWriteDate"
                        density="compact"
                        variant="outlined"
                        type="date"
                        @input="formatWriteDate"
                        hide-details
                      ></v-text-field>
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </v-col>
            <v-col cols="12" md="6">
              <v-table class="wage-transaction-table">
                <tbody>
                  <tr>
                    <td class="wage-transaction-label">급여 서비스연월</td>
                    <td>
                      <v-text-field
                        v-model="form.wageSupplyDate"
                        density="compact"
                        variant="outlined"
                        type="month"
                        hide-details
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td class="wage-transaction-label">급여 수량</td>
                    <td>
                      <v-text-field
                        v-model.number="form.wageCount"
                        type="number"
                        density="compact"
                        variant="outlined"
                        @input="calculateWageTotal"
                        hide-details
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td class="wage-transaction-label">급여 단가</td>
                    <td>
                      <v-text-field
                        v-model.number="form.wageUnitPrice"
                        type="number"
                        density="compact"
                        variant="outlined"
                        @input="calculateWageTotal"
                        hide-details
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td class="wage-transaction-label">급여 총액</td>
                    <td>
                      <v-text-field
                        v-model.number="form.wageTotalPrice"
                        type="number"
                        density="compact"
                        variant="outlined"
                        readonly
                        hide-details
                      ></v-text-field>  
                    </td>
                  </tr>
                  <tr>
                    <td class="wage-transaction-label">급여 비고</td>
                    <td>
                      <v-text-field
                        v-model="form.wageBigo"
                        density="compact"
                        variant="outlined"
                        hide-details
                      ></v-text-field>
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </v-col>
            <v-col cols="12" md="6">
              <v-table class="wage-transaction-table">
                <tbody>
                  <tr>
                    <td class="wage-transaction-label">재무 서비스연월</td>
                    <td>
                      <v-text-field
                        v-model="form.fnaSupplyDate"
                        density="compact"
                        variant="outlined"
                        type="month"
                        hide-details
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td class="wage-transaction-label">재무 수량</td>
                    <td>
                      <v-text-field
                        v-model.number="form.fnaCount"
                        type="number"
                        density="compact"
                        variant="outlined"
                        hide-details
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td class="wage-transaction-label">재무 단가</td>
                    <td>
                      <v-text-field
                        v-model.number="form.fnaUnitPrice"
                        type="number"
                        density="compact"
                        variant="outlined"
                        hide-details
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td class="wage-transaction-label">재무 총액</td>
                    <td>
                      <v-text-field
                        v-model.number="form.fnaTotalPrice"
                        type="number"
                        density="compact"
                        variant="outlined"
                        hide-details
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td class="wage-transaction-label">재무 비고</td>
                    <td>
                      <v-text-field
                        v-model="form.fnaBigo"
                        density="compact"
                        variant="outlined"
                        hide-details
                      ></v-text-field>
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="grey"
          variant="text"
          @click="dialog = false"
        >
          취소
        </v-btn>
        <v-btn
          color="blue"
          variant="elevated"
          @click="generatePdf"
          :loading="loading"
        >
          PDF 생성
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- PDF 미리보기 다이얼로그 -->
  <v-dialog v-model="pdfDialog" width="1000">
    <v-card>
      <v-card-title class="wage-transaction-title">거래명세서 미리보기</v-card-title>
      <v-card-text>
        <div v-if="pdfData" class="pdf-preview">
          <iframe
            :src="pdfSrc"
            width="100%"
            height="600px"
            frameborder="0"
          ></iframe>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="grey"
          variant="text"
          @click="pdfDialog = false"
        >
          닫기
        </v-btn>
        <v-btn
          color="green"
          variant="elevated"
          @click="downloadPdf"
        >
          다운로드
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import axios from 'axios';
import { ref, reactive, computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';

// Props 정의
interface Props {
  hasData?: boolean;
  dataCount?: number;
}

const props = withDefaults(defineProps<Props>(), {
  hasData: false,
  dataCount: 0
});

const store = useStore();

const inputWriteDate = ref(new Date().toISOString().split('T')[0]);

const form = reactive({
  whoUse: '공급받는자용',
  writeDate: '',
  supNum: '185-81-02287',
  supName: '㈜함우리',
  supBoss: '김승식',
  supAddr: '전주시 덕진구 기지로 77, 202-2803',
  supbizType: '구내식당업',
  supbizEvent: '집단급식위탁',
  supTell: '1833-7489',
  sisulName: store.state.AdminSisulName || '',
  wageCount: props.dataCount.toString(),
  wageUnitPrice: '17000',
  wageTotalPrice: '',
  wageBigo: '',
  wageSupplyDate: store.state.AdminYYMM || '',
  fnaCount: '',
  fnaUnitPrice: '',
  fnaTotalPrice: '',
  fnaBigo: '부가세 할인',
  fnaSupplyDate: store.state.AdminYYMM || '',
  code : store.state.AdminSisulCode || '',
  date : store.state.AdminYYMM || '',
  type : 'excel'
} as any)

const dialog = ref(false)
const pdfDialog = ref(false)
const loading = ref(false)
const pdfData = ref<string | null>(null)

const pdfSrc = computed(() => {
  if (pdfData.value) {
    return `data:application/pdf;base64,${pdfData.value}`
  }
  return ''
})

const openDialog = () => {
  dialog.value = true
}

const formatWriteDate = () => {
  const date = new Date(inputWriteDate.value);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const dayOfWeek = ['일', '월', '화', '수', '목', '금', '토'][date.getDay()];
  form.writeDate = `${year}년 ${month}월 ${day}일 ${dayOfWeek}요일`;
};

// 초기값 설정
onMounted(() => {
  formatWriteDate();
});

// dataCount가 변경될 때마다 wageCount 업데이트
watch(
  () => props.dataCount,
  (newValue) => {
    form.wageCount = newValue.toString();
    calculateWageTotal();
  }
);

const calculateWageTotal = () => {
  form.wageTotalPrice = form.wageCount * form.wageUnitPrice
}
const generatePdf = async () => {
  try {
    loading.value = true
    const response = await axios.post('/api/getWageTransaction', { form })
    
    if (response.data.pdf) {
      pdfData.value = response.data.pdf
      pdfDialog.value = true
      dialog.value = false
    }
  } catch (error) {
    console.error('PDF 생성 오류:', error)
    store.commit('showSnackbar', {
      text: "PDF 생성 중 오류가 발생했습니다.",
      color: "error"
    })
  } finally {
    loading.value = false
  }
}

const downloadPdf = () => {
  if (pdfData.value) {
    const link = document.createElement('a')
    link.href = `data:application/pdf;base64,${pdfData.value}`
    link.download = `거래명세서_${new Date().toISOString().split('T')[0]}.pdf`
    link.click()
  }
}
</script>

